import axios from "axios";
import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Back from "../components/button/back";
import CRUDnilaiTotal from "./CRUDnilaiTotal";

const Nilai1 = () => {
  const { questionId } = useParams();
  const [answers, setAnswers] = useState([]);
  const [OptionCorrectAnswer, setOptionCorrectAnswer] = useState({}); // Disimpan per soal
  const [questionData, setQuestionData] = useState(null);
  const [tahun, setTahun] = useState(String(new Date().getFullYear()));
  const [semester, setSemester] = useState("");
  const [warning, setWarning] = useState("");

  useEffect(() => {
    const fetchQuestionData = async () => {
      try {
        const token = localStorage.getItem("token");
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}api/questions/${questionId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        setQuestionData(response.data);

        // Ambil `OptionCorrectAnswer` untuk setiap soal
        const arrayCorrectAnswers = {};
        response.data.question.forEach((q, index) => {
          arrayCorrectAnswers[index] = q.optionCorrectAnswer.map((answer) =>
            answer.toLowerCase()
          );
        });
        setOptionCorrectAnswer(arrayCorrectAnswers);
      } catch (error) {
        console.error("Error fetching question data:", error);
      }
    };

    fetchQuestionData();
  }, [questionId]);

  useEffect(() => {
    const fetchAnswers = async () => {
      try {
        const token = localStorage.getItem("token");
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}api/answers/question/${questionId}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );

        const removePunctuation = (text) =>
          text
            .replace(/[.,\/#!$%\^&\*;:{}=\-_`~()]/g, " ")
            .replace(/\s{2,}/g, " ")
            .trim();

        const similarityPromises = response.data.map(async (answer) => {
          const mapel = answer.mapel?.toLowerCase();
          const isBindo = mapel === "bindo" || mapel === "bahasa indonesia";
          const isMtk = mapel === "mtk" || mapel === "matematika";

          const questionComparisons = await Promise.all(
            answer.question.map(async (q, index) => {
              try {
                // ===================== ISIAN =====================
                if (q.type === "isian") {
                  const arrayCorrectAnswers = OptionCorrectAnswer[index] || [];
                  if (!arrayCorrectAnswers.length) {
                    return { ...q, similarity: 0 };
                  }

                  const keyJawabanBenar = q.keyJawabanBenar || 1;

                  const normalize = (text) => {
                    if (isBindo || isMtk) return text.trim();
                    return removePunctuation(text.toLowerCase());
                  };

                  const userAnswerArray = Array.isArray(q.userAnswer)
                    ? q.userAnswer.map((a) => normalize(a))
                    : q.userAnswer?.split("|")?.map((a) => normalize(a)) || [];

                  const correctArray = arrayCorrectAnswers.map((a) =>
                    normalize(a)
                  );

                  const intersectionCount = userAnswerArray.filter((ans) =>
                    correctArray.includes(ans)
                  ).length;

                  return {
                    ...q,
                    similarity: (intersectionCount / keyJawabanBenar) * q.bobot,
                  };
                }

                // ===================== ESSAY =====================
                let correctAnswer = q.correctAnswer || "";
                let userAnswer = q.userAnswer || "";

                if (!correctAnswer || !userAnswer) {
                  return { ...q, similarity: 0 };
                }

                let endpoint = "api/compare";

                if (isBindo) endpoint = "api/compare/bindo";
                else if (isMtk) endpoint = "api/compare/mtk";

                if (!isBindo && !isMtk) {
                  correctAnswer = removePunctuation(
                    correctAnswer.toLowerCase()
                  );
                  userAnswer = removePunctuation(userAnswer.toLowerCase());
                }

                const compareResponse = await axios.post(
                  `${process.env.REACT_APP_API_URL}${endpoint}`,
                  {
                    text1: correctAnswer,
                    text2: userAnswer,
                    bobot: q.bobot,
                  },
                  {
                    headers: { Authorization: `Bearer ${token}` },
                  }
                );

                return {
                  ...q,
                  similarity: compareResponse?.data?.similarity || 0,
                };
              } catch (err) {
                console.error("Compare error:", err);
                return { ...q, similarity: 0 };
              }
            })
          );

          return { ...answer, question: questionComparisons };
        });

        const finalAnswers = await Promise.all(similarityPromises);
        setAnswers(finalAnswers);
      } catch (error) {
        console.error("Error fetching answers:", error);
      }
    };

    fetchAnswers();
  }, [questionId, OptionCorrectAnswer]);

  console.log(answers);
  const handleDelete = async (userId) => {
    if (
      !window.confirm(
        `Apakah anda yakin menghapus nilai ${
          answers.find((a) => a.studentId._id === userId)?.studentId.name
        }?`
      )
    ) {
      return;
    }
    try {
      const token = localStorage.getItem("token");
      await axios.delete(
        `${process.env.REACT_APP_API_URL}api/answers/user/${userId}/question/${questionId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setAnswers((prevAnswers) =>
        prevAnswers.filter((answer) => answer.studentId._id !== userId)
      );
    } catch (error) {
      console.error("Error deleting answer:", error);
    }
  };

  const handleSave = async () => {
    if (!semester) {
      setWarning("Semester harus diisi terlebih dahulu.");
      return;
    }

    try {
      const token = localStorage.getItem("token");
      const raporData = {
        questionId: questionId,
        createdBy: questionData.createdBy,
        mapel: questionData.mapel,
        jenis: questionData.jenis,
        kelas: questionData.kelas,
        rombel: questionData.rombel,
        tahun: tahun,
        semester: semester.toString(),
        nilai: answers.map((answer) => {
          const totalScore = answer.question.reduce((acc, q) => {
            // Periksa jika properti score ada dan tambahkan nilainya
            if (q.score !== undefined) {
              return acc + q.score;
            }

            // Logika existing untuk berbagai tipe soal
            if (q.type === "multipleChoice") {
              return acc + (q.isCorrect ? q.bobot : 0);
            } else if (q.type === "essay" || q.type === "isian") {
              return acc + (q.similarity !== null ? q.similarity : 0);
            }

            return acc;
          }, 0);

          return {
            studentId: answer.studentId._id,
            name: answer.studentId.name,
            nilaiTotal: parseFloat(totalScore.toFixed(2)),
          };
        }),
      };

      await axios.post(`${process.env.REACT_APP_API_URL}api/nilai`, raporData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      alert("Data rapor berhasil disimpan!");
    } catch (error) {
      console.error("Error saving rapor data:", error);
      if (error.response && error.response.data) {
        alert(`Gagal menyimpan data rapor: ${error.response.data.message}`);
      } else {
        alert("Gagal menyimpan data rapor.");
      }
    }
  };

  return (
    <div className="min-h-screen bg-blue-100">
      <div>
        <div className="flex justify-center py-10">
          <h2 className="text-2xl font-bold">Nilai </h2>
        </div>

        <div className="bg-white mx-5 md:mx-10 rounded-lg p-5">
          <div className="grid rounded-lg p-5 border border-slate-500 ">
            {questionData && (
              <div className="grid gap-y-2">
                <p>Kelas: {questionData.kelas}</p>
                <p>Rombel: {questionData.rombel}</p>
                <p>Mapel: {questionData.mapel}</p>
                <p>Jenis: {questionData.jenis}</p>
              </div>
            )}
            <div className="grid gap-y-2">
              <label>
                Tahun :
                <input
                  type="text"
                  value={tahun}
                  onChange={(e) => setTahun(e.target.value)}
                  className="border border-slate-500 rounded-lg px-5 md:w-auto w-4/6"
                />
              </label>
              <label>
                Semester :
                <select
                  value={semester}
                  onChange={(e) => setSemester(e.target.value)}
                  className="border border-slate-500 rounded-lg px-2"
                  required
                >
                  <option value="">pilih semester</option>
                  <option value="1">1</option>
                  <option value="2">2</option>
                </select>
              </label>
            </div>
            {warning && <p style={{ color: "red" }}>{warning}</p>}
          </div>

          <div className="border border-slate-500 mt-5 rounded-lg p-5">
            <table className="min-w-full bg-white text-sm lg:text-normal">
              <thead className="bg-gradient-to-tr from-cyan-600 to-cyan-400">
                <tr>
                  <th className="py-2 border">No</th>
                  <th className="py-2 px-4 border">Nama</th>
                  <th className="py-2 px-4 border">Total</th>
                  <th className="py-2 px-4 border">Hapus</th>
                  <th className="py-2 px-4 border">Jawaban Siswa</th>
                </tr>
              </thead>
              <tbody>
                {answers.map((answer, index) => {
                  const totalScore = answer.question.reduce((acc, q) => {
                    // Check if there is a score property for the question and add it
                    if (q.score !== undefined) {
                      return acc + q.score;
                    }

                    // Existing logic for different types of questions
                    if (q.type === "multipleChoice") {
                      return acc + (q.isCorrect ? q.bobot : 0);
                    } else if (q.type === "essay" || q.type === "isian") {
                      return acc + (q.similarity !== null ? q.similarity : 0);
                    }

                    return acc;
                  }, 0);

                  return (
                    <tr key={answer._id} className="hover:bg-gray-100">
                      <td className="py-2 px-4 border">{index + 1}</td>
                      <td className="py-2 px-4 border">
                        {answer.studentId.name}
                      </td>
                      <td className="py-2 px-4 border">
                        {totalScore.toFixed(2)}
                      </td>
                      <td className="py-2 px-4 border">
                        <button
                          className="text-red-500 hover:text-red-700"
                          onClick={() => handleDelete(answer.studentId._id)}
                        >
                          Hapus
                        </button>
                      </td>
                      <td className="py-2 px-4 border">
                        <button className="bg-green-500 text-white px-4 py-2 rounded-lg hover:bg-green-600 focus:outline-none focus:ring-2 focus:ring-green-300">
                          <Link
                            to={`/guru/jawaban-siswa/id/${answer.studentId._id}/question/${questionId}`}
                            className="block text-center"
                          >
                            Jawaban Siswa
                          </Link>
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <div className="flex justify-center ">
            <button
              className="py-2 bg-blue-300 mt-5 rounded-lg w-40 text-white font-bold hover:bg-blue-700"
              onClick={handleSave}
            >
              Simpan Rapor
            </button>
          </div>
        </div>
        <div className="flex justify-center pt-10">
          <Link to={"/guru"}>
            <Back />
          </Link>
        </div>
      </div>
      <div>
        <div>
          <CRUDnilaiTotal
            mapel={questionData?.mapel}
            questionId={questionId}
            kelas={questionData?.kelas}
            rombel={questionData?.rombel}
            tahun={tahun}
            semester={semester}
            jenis={questionData?.jenis}
          />
        </div>
      </div>
    </div>
  );
};

export default Nilai1;
